<template>
  <div class="c-input">
    <label
      class="c-input__label"
      :class="{ 'c-input__label--empty': isDirty }"
      >{{ $t("Rispondi Qui") }}</label
    >
    <div class="c-input__cnt">
      <div class="c-input__icon"><i class="far fa-calendar "></i></div>
      <input
        type="text"
        :value="val"
        @input="$emit('input', $event.target.value)"
        class="c-input__input"
      />
      <input type="date" class="c-input__input--date" @input="onInput" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Date",
  props: ["value"],
  data() {
    return {
      val: ""
    };
  },
  computed: {
    isDirty() {
      return !!this.val.length;
    }
  },
  methods: {
    onInput(e) {
      const moment = this.moment(e.target.value);
      if (moment.isValid()) {
        const date = moment.format("DD MMMM YYYY").toLowerCase();
        this.val = date;
        this.$emit("input", date);
      } else {
        this.val = "";
        this.$emit("input", "");
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.val = val;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./inputs";
.c-input__icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
}
.c-input__input--date {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  width: 100%;
  border: transparent;
  color: transparent;
  z-index: 5;

  &::after,
  &:active,
  &:focus,
  &:hover,
  &:visited,
  &:focus-within {
    color: transparent;
  }
}

/* change color of symbol on hover */
input[type="date"]:hover:after {
  color: transparent;
}
input[type="date"]::-webkit-inner-spin-button {
  display: none;
}
/* make the native arrow invisible and stretch it over the whole field so you can click anywhere in the input field to trigger the native datepicker*/
input[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  color: transparent;
  background: transparent;
}
input[type="date"]::-webkit-datetime-edit-fields-wrapper {
  display: none;
}

/* adjust increase/decrease button */
input[type="date"]::-webkit-inner-spin-button {
  z-index: 3;
}

/* adjust clear button */
input[type="date"]::-webkit-clear-button {
  z-index: 3;
}
</style>
